/** Dodo checkout (block 31) and the customer portal (block 32). */
import { checkoutResponseSchema, portalResponseSchema, } from "@nook/schema";
/** `409 already_subscribed` for a `pro` caller. */
export function startCheckout(http, plan) {
    return http.request({ path: `/v1/billing/checkout?plan=${plan}`, schema: checkoutResponseSchema });
}
/** `404 no_billing_account` until the first subscription (block 32). */
export function openBillingPortal(http) {
    return http.request({ path: "/v1/billing/portal", schema: portalResponseSchema });
}
//# sourceMappingURL=billing.js.map